// Runs `callback` once, when `element` comes within `rootMargin` of the viewport (a hidden element waits
// until it is shown). Returns a function that stops watching. Without IntersectionObserver, runs right away.
export function whenVisible (element, callback, { rootMargin = "200px" } = {}) {
  if (!("IntersectionObserver" in window)) {
    callback()
    return () => {}
  }

  const observer = new IntersectionObserver((entries) => {
    if (!entries.some((entry) => entry.isIntersecting)) return

    observer.disconnect()
    callback()
  }, { rootMargin })
  observer.observe(element)

  return () => observer.disconnect()
}
